import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateAboutPage from "./UpdateAboutPage";
import { config } from "../../../config";

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const ViewAboutPage = () => {
  const [aboutPage, setAboutPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editing, setEditing] = useState(false);
  const [photo, setPhoto] = useState("");

  const [formData, setFormData] = useState({
    headline: "",
    paragraph: "",
    imageParagraph: "",
    bottomParagraph: "",
  });

  // Fetch About Page data from API
  useEffect(() => {
    const fetchAboutPage = async () => {
      try {
        const response = await axios.get(`${apiUrl}/aboutpages`);
        const aboutPageData = response.data.aboutPages[0]; // Fetch the first aboutPage
        setAboutPage(aboutPageData); // Set the aboutPage state
        // Set the formData with the fetched aboutPage data
        setFormData({
          headline: aboutPageData.headline || "",
          paragraph: aboutPageData.paragraph || "",
          imageParagraph: aboutPageData.imageParagraph || "",
          bottomParagraph: aboutPageData.bottomParagraph || "",
        });
        setLoading(false);
      } catch (err) {
        console.error("Error fetching about page:", err);
        setError("Error fetching about page data.");
        setLoading(false);
      }
    };

    fetchAboutPage();
  }, []);

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleQuillParagraph = (content) => {
    setFormData((prev) => ({ ...prev, paragraph: content }));
  };

  const handleQuillImageParagraph = (paragraph) => {
    setFormData((prev) => ({ ...prev, imageParagraph: paragraph }));
  };

  const handleQuillBottomParagraph = (bottomparagraph) => {
    setFormData((prev) => ({ ...prev, bottomParagraph: bottomparagraph }));
  };
  

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("_method", "PUT");
    if (photo) data.append("image", photo);
    data.append("headline", formData.headline);
    data.append("paragraph", formData.paragraph);
    data.append("imageParagraph", formData.imageParagraph);
    data.append("bottomParagraph", formData.bottomParagraph);

    try {
      await axios.post(`${apiUrl}/aboutpagesupdate/${aboutPage.id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      alert("About page updated successfully.");
      setEditing(false);
      setAboutPage((prev) => ({ ...prev, ...formData, image: photo }));
    } catch (err) {
      console.error("Error updating about page:", err);
      setError("An error occurred while updating the about page.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">About Page</h2>
      {error && <p className="text-red-500">{error}</p>}
      {!editing && aboutPage && (
        <div>
          <table className="min-w-full table-auto mb-4">
            <thead>
              <tr>
                <th className="px-4 py-2">Section</th>
                <th className="px-4 py-2">Content</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border px-4 py-2">Headline</td>
                <td className="border px-4 py-2">{aboutPage.headline}</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Paragraph</td>
                <td className="border px-4 py-2">{aboutPage.paragraph}</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Image</td>
                <td className="border px-4 py-2">
                  {aboutPage.image && (
                    <img
                      src={`${imageUrl}/${aboutPage.image}`}
                      alt="About Page"
                      className="h-48 w-full object-cover"
                    />
                  )}
                </td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Image Paragraph</td>
                <td className="border px-4 py-2">{aboutPage.imageParagraph}</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Bottom Paragraph</td>
                <td className="border px-4 py-2">{aboutPage.bottomParagraph}</td>
              </tr>
            </tbody>
          </table>
          <button
            onClick={() => setEditing(true)}
            className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mt-4"
          >
            Edit
          </button>
        </div>
      )}
      {editing && (
        <UpdateAboutPage
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          setPhoto={setPhoto}
          handleQuillParagraph={handleQuillParagraph}
          handleQuillImageParagraph={handleQuillImageParagraph}
          handleQuillBottomParagraph={handleQuillBottomParagraph}
          loading={loading}
          error={error}
        />
      )}
    </div>
  );
};

export default ViewAboutPage;
